<template>
  <el-tree
    v-loading="isLoading"
    ref="authOrgTree"
    :props="props"

    :empty-text="emptyText"
    :load="loadTree"
    lazy
    node-key="id"
    :check-strictly="checkStrictly"
    :highlight-current="true"
    :show-checkbox="checkbox"
    @node-click="handleNodeClick"
  ></el-tree>
</template>
<script>
import { COMMON_ALL_ORG_TREE } from "@/store/mutation-types";
import {mapState} from "vuex";

export default {
  props: ["checkbox", "checkStrictly", "onlyUnChecked", "emptyText"],
  data() {
    return {
      isLoading: false,
      props: { label: "name" },
      treeData: [],
      checkedKeys: []
    };
  },
  computed:{
    ...mapState("app", ["currentUser"]),
  },
  created() {
    // this.isLoading = true;
    // this.$store.dispatch(SETTING_POS_DATA_AUTH_FIND_PROJECT_TREE).then(result => {
    //   this.treeData = result
    //   this.isLoading = false
    // }, () => {
    //   this.isLoading = false
    // })
  },
  methods: {
    loadTree(node, resolve) {
      if (node.level === 0) {
        this.$store.dispatch(COMMON_ALL_ORG_TREE, this.currentUser.tenancyCode)
        .then(result => {
            resolve(result);
          }).finally(()=>{
            this.isLoading = false
          })
      } else {
        this.$store.dispatch(COMMON_ALL_ORG_TREE, node.data.id)
        .then(result => {
            resolve(result);
        })
      }
    },
    /* 监听树点击事件,并抛出 change 事件 */
    handleNodeClick(data) {
      this.$emit("change", data);
    },
    setCheckedKeys(keys) {
      this.$refs["authOrgTree"].setCheckedKeys(keys);
      this.checkedKeys = this.$refs["authOrgTree"].getCheckedKeys();
    },
    setChecked(key, checked, deep) {
      this.$refs["authOrgTree"].setChecked(key, checked, deep);
      this.checkedKeys = this.$refs["authOrgTree"].getCheckedKeys();
    },
    getCheckedKeys() {
      return this.$refs["authOrgTree"].getCheckedKeys();
    },
    getHalfCheckedKeys() {
      return this.$refs["authOrgTree"].getHalfCheckedKeys();
    }
  }
};
</script>
